import { Nav } from "@/components/ui/nav"
import HomeIcon from "@/components/icons/home"
import CreditCardIcon from "@/components/icons/creditcard"
import LinkCircleIcon from "@/components/icons/link-circle"
import WalletIcon from "@/components/icons/wallet"
import ChatTextIcon from "@/components/icons/chat-text"
import SettingsCogIcon from "@/components/icons/settings-cog"
import UserIcon from "@/components/icons/user"
import PaperFoldTextIcon from "@/components/icons/paper-fold-text"
import ReceiptIcon from "@/components/icons/receipt"

interface MenuProps {
  onClick?: () => void;
}

export default function Menu({ onClick }: MenuProps) {
  return (
    <div className="flex flex-col justify-between flex-grow">
      <Nav
        links={[
          {
            title: "Home",
            to: "/",
            icon: HomeIcon,
          },
          {
            title: "Payment",
            to: "/payments",
            icon: CreditCardIcon,
          },
          {
            title: "Transaction",
            to: "/transactions",
            icon: ReceiptIcon,
          },
          {
            title: "Payment Link",
            to: "/payment-links",
            icon: LinkCircleIcon,
            testid: "payment-links",
          },
          {
            title: "Invoice",
            to: "/invoices",
            icon: PaperFoldTextIcon,
            testid: "invoices",
          },
          {
            title: "Customer",
            to: "/customers",
            icon: UserIcon,
            testid: "customers",
          },
          {
            title: "Balance",
            to: "/balances",
            icon: WalletIcon,
            testid: "balances",
          },
        ]}
        onClick={onClick}
      />
      <Nav
        links={[
          {
            title: "Support",
            to: "https://docs.braidpay.com/braidpay",
            target: "_blank",
            icon: ChatTextIcon,
          },
          {
            title: "Settings",
            to: "/settings",
            icon: SettingsCogIcon,
            testid: "settings",
          },
        ]}
        onClick={onClick}
      />
    </div>
  )
}
